export const CUSTOMERS_AMOUNT = '1,407';
